/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_No_DifferencesInputs */

const en_compare_event_groups_no_differences = /** @type {(inputs: Compare_Event_Groups_No_DifferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No differences`)
};

const fr_compare_event_groups_no_differences = /** @type {(inputs: Compare_Event_Groups_No_DifferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune différence`)
};

const de_compare_event_groups_no_differences = /** @type {(inputs: Compare_Event_Groups_No_DifferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Unterschiede`)
};

const it_compare_event_groups_no_differences = /** @type {(inputs: Compare_Event_Groups_No_DifferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna differenza`)
};

const ru_compare_event_groups_no_differences = /** @type {(inputs: Compare_Event_Groups_No_DifferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Различий нет.`)
};

const es_compare_event_groups_no_differences = /** @type {(inputs: Compare_Event_Groups_No_DifferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay diferencias`)
};

const zh_cn2_compare_event_groups_no_differences = /** @type {(inputs: Compare_Event_Groups_No_DifferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有差异`)
};

const ja_compare_event_groups_no_differences = /** @type {(inputs: Compare_Event_Groups_No_DifferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`違いはありません`)
};

const hi_compare_event_groups_no_differences = /** @type {(inputs: Compare_Event_Groups_No_DifferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई अंतर नहीं`)
};

const pt_pt2_compare_event_groups_no_differences = /** @type {(inputs: Compare_Event_Groups_No_DifferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem diferenças`)
};

/**
* | output |
* | --- |
* | "No differences" |
*
* @param {Compare_Event_Groups_No_DifferencesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_no_differences = /** @type {((inputs?: Compare_Event_Groups_No_DifferencesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_No_DifferencesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_no_differences(inputs)
	if (locale === "de") return de_compare_event_groups_no_differences(inputs)
	if (locale === "it") return it_compare_event_groups_no_differences(inputs)
	if (locale === "ru") return ru_compare_event_groups_no_differences(inputs)
	if (locale === "es") return es_compare_event_groups_no_differences(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_no_differences(inputs)
	if (locale === "ja") return ja_compare_event_groups_no_differences(inputs)
	if (locale === "hi") return hi_compare_event_groups_no_differences(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_no_differences(inputs)
	return en_compare_event_groups_no_differences(inputs)
});